import { Deserializable } from './deserializable';
import { Train } from './train';
import { NavEntity } from './nav-entity';

export class Site implements Deserializable, NavEntity {
    crspSiteName: string;
    siteId: number;
    siteName: string;
    address: string;
    city: string;
    state: string;
    country: string;
    latitude: number;
    longitude: number;
    customerId: number;
    postalCode: string;
    region: string;
    salesforceSiteId: string;
    timeZone: string;
    trains: Array<Train> = [];

    deserialize(input: any): any {
        Object.assign(this, input);
        return this;
    }

    getName(): string {
        return this.siteName;
    }

    getType(): 'customer' | 'site' | 'train' {
        return 'site';
    }

    getCollectionType() {
      return this.getType() + 's';
    }

    getId(): number {
        return this.siteId;
    }
}



// WEBPACK FOOTER //
// ./src/models/site.ts